module.exports = __webpack_public_path__ + "img/CY120002.bac41a08.png";